module.exports = __webpack_public_path__ + "static/media/step_008.af4eeb2f.jpg";